(() => {
  const containerSelector = '[data-ordovit-description]';
  const contentSelector = '[data-ordovit-description-content]';
  const buttonSelector = '[data-ordovit-description-button]';

  function getCollapsedHeight(container) {
    const value = getComputedStyle(container)
      .getPropertyValue('--ordovit-collapsed-height')
      .trim();

    const probe = document.createElement('div');
    probe.style.position = 'absolute';
    probe.style.visibility = 'hidden';
    probe.style.height = value || '0px';

    document.body.appendChild(probe);

    const height = probe.getBoundingClientRect().height;

    probe.remove();

    return height;
  }

  function setLabels(container, expanded) {
    const button = container.querySelector(buttonSelector);
    const showLabel = container.querySelector('[data-ordovit-show]');
    const hideLabel = container.querySelector('[data-ordovit-hide]');

    if (!button || !showLabel || !hideLabel) return;

    button.setAttribute('aria-expanded', expanded);

    showLabel.hidden = expanded;
    hideLabel.hidden = !expanded;
  }

  function update(container) {
    const content = container.querySelector(contentSelector);

    if (!content) return;

    const collapsedHeight = getCollapsedHeight(container);

    const needsToggle =
      content.scrollHeight > collapsedHeight + 8;

    container.classList.toggle(
      'is-collapsible',
      needsToggle
    );

    if (!needsToggle) {
      container.classList.remove('is-expanded');
      content.style.maxHeight = '';
      setLabels(container, false);
      return;
    }

    if (container.classList.contains('is-expanded')) {
      content.style.maxHeight =
        content.scrollHeight + 'px';
    } else {
      content.style.maxHeight = '';
    }
  }

  function initialize(container) {
    if (
      !container ||
      container.dataset.ordovitInitialized === 'true'
    ) {
      return;
    }

    const content = container.querySelector(contentSelector);
    const button = container.querySelector(buttonSelector);

    if (!content || !button) return;

    container.dataset.ordovitInitialized = 'true';

    setLabels(container, false);

    update(container);

    button.addEventListener('click', () => {
      const expanded =
        !container.classList.contains('is-expanded');

      container.classList.toggle(
        'is-expanded',
        expanded
      );

      setLabels(container, expanded);

      if (expanded) {
        content.style.maxHeight =
          content.scrollHeight + 'px';
      } else {
        content.style.maxHeight = '';

        const reduceMotion = window.matchMedia(
          '(prefers-reduced-motion: reduce)'
        ).matches;

        const top =
          container.getBoundingClientRect().top +
          window.scrollY -
          24;

        window.scrollTo({
          top: Math.max(top, 0),
          behavior: reduceMotion ? 'auto' : 'smooth',
        });
      }
    });

    if ('ResizeObserver' in window) {
      const observer = new ResizeObserver(() => {
        update(container);
      });

      observer.observe(content);
    }
  }

  function initializeAll(root = document) {
    root
      .querySelectorAll(containerSelector)
      .forEach(initialize);
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      () => initializeAll()
    );
  } else {
    initializeAll();
  }

  document.addEventListener(
    'shopify:section:load',
    (event) => {
      initializeAll(event.target);
    }
  );
})();